/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ExtensionOrderStatusBatchRequest interface.
 */
export function instanceOfExtensionOrderStatusBatchRequest(value) {
    if (!('amazonOrderIds' in value) || value['amazonOrderIds'] === undefined)
        return false;
    return true;
}
export function ExtensionOrderStatusBatchRequestFromJSON(json) {
    return ExtensionOrderStatusBatchRequestFromJSONTyped(json, false);
}
export function ExtensionOrderStatusBatchRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'amazonOrderIds': json['amazonOrderIds'],
    };
}
export function ExtensionOrderStatusBatchRequestToJSON(json) {
    return ExtensionOrderStatusBatchRequestToJSONTyped(json, false);
}
export function ExtensionOrderStatusBatchRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'amazonOrderIds': value['amazonOrderIds'],
    };
}
